import { render, staticRenderFns } from "./AddToCampaign.vue?vue&type=template&id=83e4bbb8&"
import script from "./AddToCampaign.vue?vue&type=script&lang=js&"
export * from "./AddToCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports